import React, { useState } from "react"
import { FiArchive, FiBell,  FiMenu,FiMoreVertical, FiTrash2, FiUser, FiUsers, FiVolumeX, FiX, FiCheckCircle, FiLayout,  FiPhone, FiSearch } from "react-icons/fi"
import clx from "classnames"
import neonStore from "../../../../stores/useNeon"
import { useDrawer } from "../../../../stores/useDrawer"


export const Option = () => {

    const [status, setStatus] = useState(false)
    
    return <div className="relative">
      {/** <!-- OPTIONS COMPONENT-->
      **/}
      <div
        // @click.away="status=false"
          onClick={()=>setStatus(!status)}
          className={clx({'hidden':!status})}
       >
        <div
          className=""
          // :className="status?'text-blue-400 ':'text-gray-400 '"
        >
         <FiMoreVertical size={23} className="cursor-pointer"/>
        </div>
        <div
          className={clx(
            {'block':status},
            {'hidden':!status},
            `dropdown absolute right-0 top-6 z-10 divide-y dark:divide-zinc-600 border dark:border-zinc-600 bg-white dark:bg-zinc-700 rounded-lg w-32`
          )}
        >
          <ul className="py-2 text-sm text-gray-200">
            <li
              className="md:hidden cursor-pointer"
              // @click="mobileDetail=!mobileDetail"
              >
              <div
                className="block text-zinc-500 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-500 px-4 py-2 flex gap-1 items-center"
              >
                <FiUsers size={23}
                  className="h-4 text-zinc-600 dark:text-zinc-300"
                />
                <p>Detail</p>
              </div>
            </li>
            <li>
              <a
                href="#"
                className="block text-zinc-500 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-500 px-4 py-2 flex gap-1 items-center"
              >
                <FiArchive size={23}
                  className="h-4 text-zinc-600 dark:text-zinc-300"
                />
                <p>Archive</p>
              </a>
            </li>
            <li>
              <a
                href="#"
                className="block text-zinc-500 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-500 px-4 py-2 flex gap-1 items-center"
              >
                <FiVolumeX size={23}
                  className="h-4 text-zinc-600 dark:text-zinc-300"
                />
                <p>Muted</p>
              </a>
            </li>
            <li>
              <a
                href="#"
                className="block text-zinc-500 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-500 px-4 py-2 flex gap-1 items-center"
              >
                <FiTrash2 size={23}
                  className="h-4 text-zinc-600 dark:text-zinc-300"
                />
                <p>Delete</p>
              </a>
            </li>
            <li>
              <a
                href="#"
                className="block text-zinc-500 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-500 px-4 py-2 flex gap-1 items-center"
              >
                <FiX size={23}
                  className="h-4 text-zinc-600 dark:text-zinc-300"
                />
                <p>Close</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    
}

